<template>
    <main-container class="main-container">
        <sep name="M"/>

        <div class="Number résults" v-if="queryTerm && conventions && conventions.length">
            <typo><b>{{ conventions.length }}</b> conventions collectives correspondent à la recherche "{{ queryTerm }}"</typo>
        </div>

        <sep name="M"/>

        <div class="Number résults" v-if="queryTerm && conventions && !conventions.length">
            Aucune convention collective ne correspond à la recherche "{{ queryTerm }}".
            Pour toute recherche par mot-clé ou numérique (code APE/NAF ou Brochure ou IDCC) saisir 4 caractères minimum (exemple IDCC 43 : saisir 0043)
        </div>

        <convention-teaser 
            v-for="convention in conventions" 
            mode="search-result" 
            :parentConvention="convention" 
            :selectedConvention="convention.selectedChildConvention ? convention.selectedChildConvention : convention"
            :key="convention._uid"
        />

    </main-container>
</template>

<script>

import ConventionTeaser from "src/components/convention/teaser/ConventionTeaser.vue";

export default {
    components: { ConventionTeaser },
    props: ["conventions", "query"],
    computed: {
        queryTerm() {
            if ( !this.query ) {
                return null;
            }
            if ( typeof this.query == "object" ) {
                switch ( this.query.type ) {
                    case "text":
                        return this.query.suggestion;
                    case "code":
                        switch ( this.query.subtype ) {
                            case "brochure":
                                return `Brochure n°${this.query.suggestion}`;
                            case "idcc":
                                return  `IDCC n°${this.query.suggestion}`;
                            default:
                                return `Code ${this.query.suggestion}`;
                        }
                    default:
                        return null;
                }
            } else {
                return this.query;
            }
        }
    }
}
</script>

<style scoped lang="sass">

</style>